import React from "react";

function dashboardSVGNew({
  isActive, 
  activeColor = "#232323",
  inactiveColor = "#868686" }: 
  { isActive: boolean; activeColor?: string; inactiveColor?: string; }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill={isActive ? activeColor : inactiveColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3332 9.33342V14.6667C13.3332 15.0203 13.1927 15.3594 12.9427 15.6095C12.6926 15.8595 12.3535 16 11.9999 16H9.99995V13.8134V11.6267C9.99995 11.0963 9.78924 10.5876 9.41418 10.2125C9.03911 9.83745 8.53042 9.62674 8 9.62674C7.46958 9.62674 6.96089 9.83745 6.58582 10.2125C6.21076 10.5876 6.00005 11.0963 6.00005 11.6267L6.00005 16H4.00011C3.6465 16 3.30737 15.8595 3.05732 15.6095C2.80728 15.3594 2.66681 15.0203 2.66681 14.6667V9.33342H1.33351C1.06978 9.33347 0.811959 9.25529 0.59266 9.10879C0.373361 8.96228 0.202436 8.75403 0.101504 8.51038C0.000572041 8.26672 -0.0258321 7.9986 0.0256313 7.73993C0.0770947 7.48127 0.204114 7.24367 0.390622 7.0572L7.05711 0.390627C7.18092 0.266785 7.32792 0.168546 7.4897 0.101522C7.65148 0.0344973 7.82488 0 8 0C8.17512 0 8.34852 0.0344973 8.5103 0.101522C8.67208 0.168546 8.81908 0.266785 8.94289 0.390627L15.6094 7.0572C15.7959 7.24367 15.9229 7.48127 15.9744 7.73993C16.0258 7.9986 15.9994 8.26672 15.8985 8.51038C15.7976 8.75403 15.6266 8.96228 15.4073 9.10879C15.188 9.25529 14.9302 9.33347 14.6665 9.33342H13.3332Z"
        // fill={inactiveColor}
        fill={isActive ? activeColor : inactiveColor}
      />
    </svg>
  );
}

export default dashboardSVGNew;
